import { useState } from "react";
import axios from "axios";
import { Loader2, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REGIMES = [
  ["eu_nonvat", "Firma z EÚ bez IČ DPH — slovenská DPH 23 %"],
  ["domestic", "Tuzemsko (SK) — DPH 23 %"],
  ["", "Automaticky podľa údajov odberateľa"],
];

export default function InvoiceCorrect({ inv, token, onDone }) {
  const [open, setOpen] = useState(false);
  const [regime, setRegime] = useState("eu_nonvat");
  const [reason, setReason] = useState("oprava uplatnenia DPH — odberateľ je podnikateľ (IČO), nie je platiteľ DPH");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async () => {
    if (!window.confirm(`Vystaviť opravnú faktúru k č. ${inv.number}, pôvodnú zrušiť a poslať ju zákazníkovi (kópia vám)?`)) return;
    setBusy(true); setMsg("");
    try {
      const { data } = await axios.post(`${API}/admin/invoices/${inv.id}/correct`, { regime, reason, send: true }, { headers: { Authorization: `Bearer ${token}` } });
      const n = data.invoice;
      setMsg(`Vystavená opravná faktúra č. ${n.number}: ${n.amount_base.toFixed(2)} € + ${n.vat_amount.toFixed(2)} € DPH = ${n.amount_total.toFixed(2)} €. Odoslaná.`);
      setOpen(false); onDone && onDone();
    } catch (e) { setMsg(e?.response?.data?.detail || "Opravu sa nepodarilo vystaviť."); }
    finally { setBusy(false); }
  };

  if (!open) return (
    <div className="mt-3">
      <button onClick={() => setOpen(true)} data-testid="invoice-correct-open"
        className="inline-flex items-center gap-1.5 border border-[#D4AF37]/40 text-[#D4AF37] px-3 py-1.5 text-xs hover:bg-[#D4AF37]/10 transition-colors">
        <RefreshCw size={13} /> Opraviť faktúru (nová opravná)
      </button>
      {msg && <p className="text-[#D4AF37] text-xs mt-2" data-testid="invoice-correct-msg">{msg}</p>}
    </div>
  );
  return (
    <div className="mt-4 border border-[#D4AF37]/30 bg-[#111] p-4 space-y-3" data-testid="invoice-correct-panel">
      <p className="text-white/70 text-sm">Vznikne nová faktúra s novým číslom, celková suma {Number(inv.amount_total).toFixed(2)} € ostane rovnaká a DPH sa prepočíta. Pôvodná sa označí ako zrušená.</p>
      <select value={regime} onChange={(e) => setRegime(e.target.value)} data-testid="invoice-correct-regime"
        className="w-full bg-black border border-white/15 px-3 py-2 text-sm text-white focus:border-[#D4AF37] outline-none">
        {REGIMES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Dôvod opravy" data-testid="invoice-correct-reason"
        className="w-full bg-black border border-white/15 px-3 py-2 text-sm text-white focus:border-[#D4AF37] outline-none" />
      <div className="flex gap-3">
        <button onClick={submit} disabled={busy} data-testid="invoice-correct-submit"
          className="inline-flex items-center gap-2 bg-[#D4AF37] text-black px-4 py-2 text-sm font-semibold hover:bg-[#F2E3C6] disabled:opacity-50">
          {busy && <Loader2 size={14} className="animate-spin" />} Vystaviť opravu a odoslať
        </button>
        <button onClick={() => setOpen(false)} className="border border-white/15 px-4 py-2 text-sm text-white/60 hover:text-white">Zrušiť</button>
      </div>
    </div>
  );
}
